"use client";

import {
  HybridHeroData,
  hybridStatsData,
  hybridAppServices,
  hybridSolutionsAndProcessData,
  hybridTechnologiesData,
  hybridAboutData,
  hybridAppFaqs,
} from "src/utils/mock/hybridAppMock";
import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import NavigationSection from "src/components/Common/NavigationSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function HybridAppDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const hybridProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";
    const mobileApp = project.platforms?.toLowerCase().includes("mobile");
    const hasHybridTech = project.technologies?.some((tech) => tech.name?.toLowerCase().includes("hybrid"));

    return isActive && mobileApp && hasHybridTech;
  });

  const filteredData = {
    ...finalCaseStudies,
    projects: {
      ...finalCaseStudies?.projects,
      liveProjects: hybridProjects,
    },
  };

  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={HybridHeroData} />

      <TechStats stats={hybridStatsData} />

      <NavigationSection data={hybridAppServices} />

      <WhyChooseUs data={hybridSolutionsAndProcessData} />
      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={hybridTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={hybridAboutData} mainTitle="About Our Hybrid App Development" />
        </div>
      </section>

      <FAQSection faqs={hybridAppFaqs} />
      <CommonContactSection />
    </div>
  );
}
